module.exports = __webpack_public_path__ + "img/362.9df40ec9.jpg";